module.exports = __webpack_public_path__ + "img/bingo_ball-15.a46a5efe.png";